import React, { useEffect, useState } from "react";
import { logos, Logo } from "../config/logoConfig";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

interface AnimatedLogoProps {
  color?: string;
  customClass?: string;
  isFromNav?: boolean;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({
  color = "blue",
  customClass = "",
  isFromNav = false,
}) => {
  const [lottieFile, setLottieFile] = useState<string | null>(null);

  const getLottieForToday = (): string | null => {
    const today = new Date();
    if (!Array.isArray(logos)) {
      console.warn('Logos is not an array:', logos);
      return null;
    }
    
    try {
      for (const logoCandidate of logos) {
        const startDate = new Date(logoCandidate.startDate);
        const endDate = new Date(logoCandidate.endDate);
        if (
          today >= startDate &&
          today <= endDate &&
          logoCandidate.color === color
        ) {
          return logoCandidate.lottieFile;
        }
      }
    } catch (error) {
      console.error('Error processing logos:', error);
    }
    return null;
  };

  useEffect(() => {
    const currentLottie = getLottieForToday();
    if (currentLottie) {
      setLottieFile(currentLottie);
    }
  }, [color]);

  return (
    <div className={customClass} style={{ display: "flex", justifyContent: "flex-start" }}>
      {lottieFile ? (
        <DotLottieReact
          src={lottieFile}
          loop
          autoplay
          style={{
            height: isFromNav ? "60px" : "70px",
            width: isFromNav ? "180px" : "120px",
          }}
        />
      ) : (
        <img
          src={
            color === "blue"
              ? "https://d2nnrpx7gk2my2.cloudfront.net/files/66e42c3e698d2800087805f2/Frame.svg"
              : "https://d2nnrpx7gk2my2.cloudfront.net/files/670417abc4d989000847b56a/Frame.svg"
          }
          alt="Default Logo"
          style={{ width: "auto", height: "35px" }}
        />
      )}
    </div>
  );
};

export default AnimatedLogo;
